var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper"},[_c('v-icon',{attrs:{"small":"","color":"black"}},[_vm._v("far fa-clock")]),_c('VueTimepicker',{attrs:{"minute-interval":_vm.interval,"format":"HH:mm","hide-clear-button":""},model:{value:(_vm._time),callback:function ($$v) {_vm._time=$$v},expression:"_time"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }